import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';

interface IAthletePackageCancellationErrorModalProps {
  opened: boolean;
  onClose: () => void;
}

const AthletePackageCancellationErrorModal = ({
  opened,
  onClose,
}: IAthletePackageCancellationErrorModalProps): JSX.Element => {
  return (
    <Modal centered opened={opened} onClose={onClose} size='md'>
      <Title order={4} ta='center' pr='md'>
        Your package cannot be canceled <br /> right now.
      </Title>

      <Stack p='xl'>
        <Text ta='center'>
          This package includes retail items or fees and cannot be cancelled at the moment. Please contact
          the gym to resolve this, once this is addressed, you will be able to proceed with the cancellation.
        </Text>
        <Group position='center'>
          <Button onClick={onClose} variant='outline'>
            Go Back
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default AthletePackageCancellationErrorModal;
